<template>
  <div class="gogo">
    <mainmenu :menuArray="['首页', '网站制作', '我的订单','关于我们']" :selectMenu="'最新上线'"></mainmenu>
  </div>

</template>

<script>
import Mainmenu from './mainmenu'
export default {
  name: 'HelloWorld',
  components: {Mainmenu},
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .gogo{
    flex-shrink: 0;
    flex-direction: column;
    align-content: flex-start;
    align-items: flex-start;
    display: flex;
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue